import { render, staticRenderFns } from "./ChangeFeesModal.vue?vue&type=template&id=7efc6997&scoped=true&"
import script from "./ChangeFeesModal.vue?vue&type=script&lang=js&"
export * from "./ChangeFeesModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeFeesModal.vue?vue&type=style&index=0&id=7efc6997&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efc6997",
  null
  
)

export default component.exports